import { Button } from "./Button";
import { Body } from "./Text";

interface ErrorViewProps {
  readonly message: string;
  readonly onRetry?: () => void;
}

/** A failure, said plainly, with the one thing the person can do about it. */
export function ErrorView({ message, onRetry }: ErrorViewProps) {
  return (
    <div role="alert" className="mt-4">
      <Body>{message}</Body>
      {onRetry && (
        <div className="mt-4">
          <Button label="Try again" outlined onClick={onRetry} />
        </div>
      )}
    </div>
  );
}
